export type StopContactField = "stop_contact_name" | "stop_contact_number" | "stop_contact_email";

export type StopPlanningField =
  | "stop_time_type"
  | "stop_after_date"
  | "stop_after_time"
  | "stop_before_date"
  | "stop_before_time"
  | "stop_timezone"
  | "stop_hours_start"
  | "stop_hours_end"
  | "stop_notes";

export type StopAddressField =
  | "stop_address_type"
  | "address_name"
  | "address_id"
  | "address_reference_number"
  | "street_address"
  | "street_address_line_two"
  | "city_name"
  | "state_name"
  | "country_name"
  | "zipcode"
  | "stop_airport_name"
  | "stop_airport_code"
  | "stop_seaport_name"
  | "stop_seaport_code"
  | "port_country";

export type StopWatchField = "stop_type" | "country_id" | "state_name" | "stop_address_type";

export type StopField = StopContactField | StopPlanningField | StopAddressField | StopWatchField;

export function getStopFieldPath(index: number, field: StopField) {
  return `schedule.stops.${index}.${field}` as const;
}
